import { useContext, useEffect, useState } from 'react';
import { StateContext } from '../../App';

const excludedPagesFromLockedState = ['/pages'];

const useLockedState = () => {
  const state = useContext(StateContext);

  useEffect(() => {
    const users = Object.values(state.tracking?.users).filter((u) => u.route === window.location.pathname);
    if (!users || users.length <= 1 || excludedPagesFromLockedState.includes(window.location.pathname)) {
      setLockedState(false);
      return;
    }
    const firstUserToOpenPage = users.reduce((prev, curr) => (Number(prev.timestamp) < Number(curr.timestamp) ? prev : curr), {});
    if (firstUserToOpenPage.trackingId === state.session?.sessionId) {
      setLockedState(false);
    } else {
      setLockedState(true);
    }
  }, [state.tracking?.users]);

  const [lockedState, setLockedState] = useState(true);

  return {
    lockedState
  };
};

export default useLockedState;
